module.exports = "/assets/446ad970499118ed7fee1f9567006521.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2N.png
// module id = 989
// module chunks = 0